import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../../components/Intl/WithIntl';
import Helmet from 'react-helmet';
import { Row, Col, Card, CardBody, CardImgOverlay, CardImg, Alert, Button } from 'reactstrap';

import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import config from '../../../../config';

// Import Components
import UserLoginForm from '../../components/auth/UserLoginForm';
import { getLoggedUser } from '../../UserActions';

function UserLoginPage({ intl, user = null, redirect = null }) {
    return (
        <Fragment>
            <Helmet
                title={intl.formatMessage({
                    id: 'userLogin',
                    defaultMessage: 'Login',
                })}
                meta={[
                    {
                        name: 'robots',
                        content: 'noindex',
                    },
                ]}
            />
            <Row className="g-0 mt-2 mt-md-5 py-5">
                <Col sm={{ size: 12, offset: 0 }} md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }}>
                    {/* <h1 className="p-5 text-center">
                        <img src={`${config.staticUrl}images/logo-managexam.jpg`} alt={config.application.name} /><br />
                    </h1> */}
                    <Card className="shadow">
                        {/* <CardImg
                            src={`${config.staticUrl}images/app/managexam-login.png`}
                            role="presentation"
                            style={{ width: '100%' }}
                        /> */}
                        <CardBody>
                            {
                                user
                                ? (
                                    <Alert color="light" className="text-center">
                                        <h4><FontAwesomeIcon icon="hands-clapping" size="2x" /> <FormattedMessage id="appWelcome" defaultMessage="Welcome {name}!" values={{ name: user.firstName }} /></h4>
                                        <Button tag={Link} to="/" color="primary" className="mt-3"><FontAwesomeIcon icon="house" /> <FormattedMessage id="dashboardTitle" defaultMessage="Dashboard" /></Button>
                                    </Alert>
                                ) : <UserLoginForm redirect={redirect || null} />
                            }
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );
}

function mapStateToProps(store, props) {
    return {
        user: getLoggedUser(store),
    };
}

UserLoginPage.propTypes = {
    intl: PropTypes.object.isRequired,
    redirect: PropTypes.string,
};

export default connect(mapStateToProps)(withIntl(UserLoginPage));
